import React, { useImperativeHandle, useRef, useState } from 'react'

import CloseIcon from 'mdi-react/CloseIcon'
import FocusLock from 'react-focus-lock'
import { useDispatch, useSelector } from 'react-redux'

import KeyDownCatcher from '@/components/util/KeyDownCatcher'
import { closeModal, getIsActive } from '@/ducks/modalReducer'
import { useMountEffect } from '@/hooks/mounting-hooks'

import './modal.scss'

export let modalRef = null

const Modal = () => {
  const ref = useRef()
  const dispatch = useDispatch()

  const isActive = useSelector(getIsActive)
  // @ts-ignore
  const close = () => dispatch(closeModal())

  useMountEffect(() => {
    // @ts-ignore
    modalRef = ref
  })

  return (
    <div className={`modal ${isActive ? 'active' : 'inactive'}`}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className="modal__overlay" onClick={close} />
      <ModalContainer ref={ref} />
    </div>
  )
}

const ModalContainer = React.forwardRef((props, inputRef) => {
  const dispatch = useDispatch()
  // @ts-ignore
  const [children, setChildren] = useState(props.children)
  const [isWide, setIsWide] = useState(false)

  const isActive = useSelector(getIsActive)
  // @ts-ignore
  const close = () => dispatch(closeModal())

  useImperativeHandle(inputRef, () => ({
    // @ts-ignore
    update: (children, isWide = false) => {
      setChildren(children)
      setIsWide(isWide)
    },
  }))

  return (
    // @ts-ignore
    <KeyDownCatcher disabled={!isActive} onEsc={close}>
      {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
      <FocusLock disabled={!isActive} autoFocus={false}>
        <div className={`modal__container ${isWide ? 'is-wide' : ''}`}>
          {/* @ts-ignore */}
          <div className="modal__content" ref={inputRef}>
            {children}
          </div>
          <button className="close-modal-button" onClick={close}>
            <CloseIcon />
          </button>
        </div>
      </FocusLock>
    </KeyDownCatcher>
  )
})

export default Modal
